import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { goTo, useLang } from "@/i18n";
import { AIRPORTS, CONTACT } from "@/data";
import { Logo } from "@/components/Logo";

export function Footer() {
  const { t, lang } = useLang();
  const links = [
    { id: "services", key: "nav_services" },
    { id: "airports", key: "nav_airports" },
    { id: "about", key: "nav_about" },
    { id: "payments", key: "nav_payments" },
    { id: "contact", key: "nav_contact" },
  ];
  return (
    <footer data-testid="site-footer" className="border-t border-blue-500/15 bg-[#050910]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm leading-relaxed text-slate-400">{t("footer_tag")}</p>
          </div>
          <div>
            <div className="font-mono-tag text-xs tracking-[0.25em] uppercase text-blue-400 mb-4">{t("footer_links")}</div>
            <ul className="space-y-2.5">
              {links.map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-link-${l.id}`} onClick={() => goTo(l.id)} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {t(l.key)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-mono-tag text-xs tracking-[0.25em] uppercase text-blue-400 mb-4">{t("footer_airports")}</div>
            <div className="flex flex-wrap gap-1.5" dir="ltr">
              {AIRPORTS.map((a) => (
                <span key={a.code} className="font-mono-tag text-[10px] text-slate-400 border border-blue-500/20 rounded px-1.5 py-0.5">{a.code}</span>
              ))}
            </div>
          </div>
          <div>
            <div className="font-mono-tag text-xs tracking-[0.25em] uppercase text-blue-400 mb-4">{t("footer_contact")}</div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a data-testid="footer-ops-email" href={`mailto:${CONTACT.opsEmail}`} className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={14} className="text-blue-400" /><span dir="ltr">{CONTACT.opsEmail}</span></a></li>
              <li><a data-testid="footer-phone" href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={14} className="text-blue-400" /><span dir="ltr" className="font-mono-tag">{CONTACT.phoneDisplay}</span></a></li>
              <li><a data-testid="footer-whatsapp" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors"><MessageCircle size={14} className="text-emerald-400" />WhatsApp 24/7</a></li>
              <li className="flex items-center gap-2"><MapPin size={14} className="text-blue-400" />{t("contact_hq_value")}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-blue-500/10 pt-7">
          <p className="text-xs text-slate-500">{t("footer_rights")}</p>
          <p className="font-mono-tag text-[10px] tracking-[0.3em] text-blue-500/60 uppercase" dir="ltr">world-was.ly · HLLM / MJI · 24/7 OCC</p>
        </div>
      </div>
    </footer>
  );
}
